// extracted by mini-css-extract-plugin
export default {"projectsHeader":"o5QxJk4I","MuiButtonBase-root":"xv_1Rxa1","projectTitle":"yT8Di5zk","addProjectDialog":"KWdzRLVH"};